import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import logoIskola from 'assets/images/logo.svg';
import logoOvi from 'assets/images/auth/logo_ovi.svg';
import styles from './SplitShell.module.css';

const SplitShell = ({ kicker, title, text, backHref, backLabel, children }) => {
  return (
    <div className={`${styles.theme} ${styles.shell}`}>
      {backHref && (
        <a href={backHref} className={styles.backLink}>
          <ArrowBackIosNewIcon />
          {backLabel}
        </a>
      )}
      <aside className={styles.panel}>
        <div className={styles.panelInner}>
          <p className={styles.panelKicker}>{kicker}</p>
          <p className={styles.panelTitle}>{title}</p>
          <p className={styles.panelText}>{text}</p>
        </div>
      </aside>
      <div className={styles.cardWrap}>
        <main className={styles.card}>
          <div className={styles.brand}>
            <div className={styles.brandPair}>
              <img src={logoIskola} alt='Iskolaévkönyv' />
              <span className={styles.brandDivider} aria-hidden='true'>
                |
              </span>
              <img src={logoOvi} alt='OviAlbum' />
            </div>
            <p className={styles.brandCaption}>{kicker}</p>
          </div>
          {children}
        </main>
      </div>
    </div>
  );
};

export default SplitShell;
